<div [hidden]="isGuest" class="mt-3" *ngIf="style === tableStyle.Short">
  <div class="table-title card-header" [style.border-bottom-color]="state === 'collapsed' ? '$main-orange' : null">
    <div class=" table-header d-flex">
      <h4 class="table-title">
        <a>
          <i [ngClass]="state === 'collapsed' ? 'fa fa fa-arrow-down' : 'fa fa fa-arrow-up'" (click)="toggle()"></i>
        </a>
        {{store.title}}
      </h4>
      <a>
        <button type="button" class="btn btn-light" *ngIf="tableInfoExists" (click)="openDialog()"><i
            class="fa fa-info-circle fa-sm"></i></button>
      </a>
    </div>
  </div>
  <div class="table-responsive" [@detailExpand]="state">
    <table class="table footable" data-paging="true" data-filtering="true" data-sorting="true"
      data-breakpoints='{ "xs": 480, "sm": 768, "md": 992, "lg": 1200, "xl": 1400 }' matSort
      (matSortChange)="sortRecords($event)">
      <thead class="thead-dark">
        <tr>
          <th scope="col" mat-sort-header="Isin">Isin</th>
          <th scope="col" mat-sort-header="Nome">Nome</th>
          <th scope="col" mat-sort-header="Scadenza">Scadenza</th>
          <th scope="col" mat-sort-header="Strike">Strike</th>
          <th scope="col" mat-sort-header="Protezione">Protezione</th>
          <th scope="col" mat-sort-header="Cap">Cap</th>
          <th scope="col" mat-sort-header="Prezzo Sott.">Prezzo Sott.</th>
          <th scope="col" mat-sort-header="Prezzo Cert.">Prezzo Cert.</th>
          <th scope="col" mat-sort-header="Rts">Rts</th>
          <th scope="col" mat-sort-header="Sconto">Sconto</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let record of store.sortedRecords">
          <td><a [routerLink]="['/menu/scheda-certificato']" [queryParams]="{ isin: record.isin }">{{record.isin ? record.isin : '--'}}</a></td>
          <td>{{record.nome ? record.nome : '--'}}</td>
          <td>{{record.scadenza ? (record.scadenza | date:'dd/MM/yyyy') : '--'}}</td>
          <td>{{record.strike ? (record.strike | number:'1.0-2':'fr') : '--'}}</td>
          <td>{{record.protezione ? (record.protezione | number:'1.0-2':'fr') : '--'}}</td>
          <td>{{record.cap ? (record.cap | number:'1.0-2':'fr') : '--'}}</td>
          <td>{{record.prezzosott ? (record.prezzosott | number:'1.0-4':'fr') : '--'}}</td>

          <td>{{record.prezzocert ? (record.prezzocert | currency:currencySymbol(record.valuta):'symbol':'1.2-2':localeCurrency(record.valuta)) : '--'}}</td>
          <td>{{record.rts ? (record.rts | currency:currencySymbol(record.valuta):'symbol':'1.2-2':localeCurrency(record.valuta)) : '--'}}</td>

          <td>{{record.sconto ? (record.sconto/100 | percent:'1.0-2') : '--'}}</td>
          <td>
            <a (click)="addToWatchlist(record.isin)" matTooltip="Aggiungi isin ad una watchlist">
              <img [src]="'assets/images/icons/addToWatchlistGlassesSmall.png'" alt="Aggiungi alla watchlist" class="watchlistIcon">
            </a>
          </td>
        </tr>
      </tbody>
      <tfoot *ngIf="!showLoader" class="footer-view-all">
      <tr>
        <td colspan="100%">
          <a class="nav-link" [routerLink]="store.viewAllPath">
            <i class="fa fa-plus"></i> Visualizza tutti
          </a>
        </td>
      </tr>
      </tfoot>
    </table>
    <div class="d-flex justify-content-center">
      <app-loader *ngIf="showLoader"></app-loader>
    </div>
  </div>
</div>

<div [hidden]="isGuest" class="container-fluid mt-3" style="position: relative"
  *ngIf="style === tableStyle.Extended">
  <div class=" table-header d-flex">
    <h4 class="view-all-table-title">
      {{store.title}}
    </h4>
    <mat-form-field class="ml-auto" *ngIf="store.totalRecords > 20">
      <mat-label>Elementi per pagina</mat-label>
      <select matNativeControl (change)="updateSize($event)">
        <option value="20" selected>20</option>
        <option value="30">30</option>
        <option value="40">40</option>
      </select>
    </mat-form-field>
    <a>
      <button type="button" class="btn btn-light" *ngIf="tableInfoExists" (click)="openDialog()"><i
          class="fa fa-info-circle fa-sm"></i></button>
    </a>
  </div>
  <div class="table-responsive">
    <table class="table footable" data-paging="true" data-filtering="true" data-sorting="true"
      data-breakpoints='{ "xs": 480, "sm": 768, "md": 992, "lg": 1200, "xl": 1400 }' matSort
      (matSortChange)="deepSortRecords($event)">
      <thead class="thead-dark">
        <tr>
          <th scope="col" mat-sort-header="isin">Isin</th>
          <th scope="col" mat-sort-header="emittente">Emittente</th>
          <th scope="col" mat-sort-header="nome">Nome</th>
          <th scope="col" mat-sort-header="sottostante">Sottostante</th>
          <th scope="col" mat-sort-header="scadenza">Scadenza</th>
          <th scope="col" mat-sort-header="strike">Strike</th>
          <th scope="col" mat-sort-header="protezione">Protezione</th>
          <th scope="col" mat-sort-header="cap">Cap</th>
          <th scope="col" mat-sort-header="prezzosott">Prezzo Sott.</th>
          <th scope="col" mat-sort-header="prezzocert">Prezzo Cert.</th>
          <th scope="col" mat-sort-header="rts">Rts</th>
          <th scope="col" mat-sort-header="sconto">Sconto</th>
          <th scope="col" mat-sort-header="rendimentoAnnuo">Sconto A/A</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let record of store.sortedRecords">
          <td><a [routerLink]="['/menu/scheda-certificato']" [queryParams]="{ isin: record.isin }">{{record.isin ? record.isin : '--'}}</a></td>
          <td>{{record.emittente ? record.emittente : '--'}}</td>
          <td>{{record.nome ? record.nome : '--'}}</td>
          <td *ngIf="record.sottostante">
            <a [routerLink]="[ '/menu/sottostante']"
              [queryParams]="{ sottostante: record.sottostante}">{{record.sottostante ? record.sottostante : '--'}}</a>
          </td>
          <td *ngIf="!record.sottostante">{{'--'}}</td>
          <td>{{record.scadenza ? (record.scadenza | date:'dd/MM/yyyy') : '--'}}</td>
          <td>{{record.strike ? (record.strike | number:'1.0-2':'fr') : '--'}}</td>
          <td>{{record.protezione ? (record.protezione | number:'1.0-2':'fr') : '--'}}</td>
          <td>{{record.cap ? (record.cap | number:'1.0-2':'fr') : '--'}}</td>
          <td>{{record.prezzosott ? (record.prezzosott | number:'1.0-4':'fr') : '--'}}</td>

          <td>{{record.prezzocert ? (record.prezzocert | currency:currencySymbol(record.valuta):'symbol':'1.2-2':localeCurrency(record.valuta)) : '--'}}</td>
          <td>{{record.rts ? (record.rts | currency:currencySymbol(record.valuta):'symbol':'1.2-2':localeCurrency(record.valuta)) : '--'}}</td>

          <td>{{record.sconto ? (record.sconto/100 | percent:'1.0-2':'fr') : '--'}}</td>
          <td>{{record.rendimentoAnnuo ? (record.rendimentoAnnuo/100 | percent:'1.0-2':'fr') : '--'}}</td>
          <td>
            <a (click)="addToWatchlist(record.isin)" matTooltip="Aggiungi isin ad una watchlist">
              <img [src]="'assets/images/icons/addToWatchlistGlassesSmall.png'" alt="Aggiungi alla watchlist" class="watchlistIcon">
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div style="padding-top: 15px" *ngIf="store.totalRecords > pageSize">
    <nav>
      <ul class="pagination pagination-circle pg justify-content-center">
        <li class="page-item">
          <a class="page-link" (click)="firstPage()">First</a>
        </li>
        <li [ngClass]="pageNumber === 1 ? 'page-item disabled' : 'page-item'">
          <a class="page-link" (click)="previousPage()" title="Previous">
            <span aria-hidden="true">&laquo;</span>
            <span class="sr-only">Previous</span>
          </a>
        </li>
        <li class="page-item active">
          <a class="page-link">{{pageNumber}}</a>
        </li>
        <li class="page-item" [ngClass]="pageNumber === totalPages ? 'page-item disabled' : 'page-item'">
          <a class="page-link" (click)="nextPage()" title="Next">
            <span aria-hidden="true">&raquo;</span>
            <span class="sr-only">Next</span>
          </a>
        </li>
        <li class="page-item">
          <a class="page-link" (click)="lastPage()">Last</a>
        </li>
      </ul>
    </nav>
  </div>
  <div [ngClass]="showLoader ? 'd-flex justify-content-center loading' : 'd-flex justify-content-center'">
    <app-loader *ngIf="showLoader"></app-loader>
  </div>
</div>

<div [hidden]="!isGuest" class="mt-3" *ngIf="style === tableStyle.Short">
  <div class="table-title card-header" [style.border-bottom-color]="state === 'collapsed' ? '$main-orange' : null">
    <div class=" table-header d-flex">
      <h4 class="table-title">
        <a>
          <i [ngClass]="state === 'collapsed' ? 'fa fa fa-arrow-down' : 'fa fa fa-arrow-up'" (click)="toggle()"></i>
        </a>
        {{store.title}}
      </h4>
      <a>
        <button type="button" class="btn btn-light" *ngIf="tableInfoExists" (click)="openDialog()"><i
            class="fa fa-info-circle fa-sm"></i></button>
      </a>
    </div>
  </div>
  <div class="table-responsive" [@detailExpand]="state">
    <table class="table footable" data-paging="true" data-filtering="true" data-sorting="true"
      data-breakpoints='{ "xs": 480, "sm": 768, "md": 992, "lg": 1200, "xl": 1400 }' matSort
      (matSortChange)="sortRecords($event)">
      <thead class="thead-dark">
        <tr>
          <th scope="col" mat-sort-header="Isin">Isin</th>
          <th scope="col" mat-sort-header="Nome">Nome</th>
          <th scope="col" mat-sort-header="Scadenza">Scadenza</th>
          <th scope="col" mat-sort-header="Strike">Strike</th>
          <th scope="col" mat-sort-header="Protezione">Protezione</th>
          <th scope="col" mat-sort-header="Cap">Cap</th>
          <th scope="col" mat-sort-header="Prezzo Sott.">Perzzo Sott.</th>
          <th scope="col" mat-sort-header="Prezzo Cert.">Prezzo Cert.</th>
          <th scope="col" mat-sort-header="Rts">Rts</th>
          <th scope="col" mat-sort-header="Sconto">Sconto</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let record of store.sortedRecordsGuest">
          <td><a [routerLink]="['/menu/scheda-certificato']" [queryParams]="{ isin: record.isin }">{{record.isin ? record.isin : '--'}}</a></td>
          <td>{{record.nome ? record.nome : '--'}}</td>
          <td>{{record.scadenza ? (record.scadenza | date:'dd/MM/yyyy') : '--'}}</td>
          <td>{{record.strike ? (record.strike | number:'1.0-2':'fr') : '--'}}</td>
          <td>{{record.protezione ? (record.protezione | number:'1.0-2':'fr') : '--'}}</td>
          <td>{{record.cap ? (record.cap | number:'1.0-2':'fr') : '--'}}</td>
          <td>{{record.prezzosott ? (record.prezzosott | number:'1.0-4':'fr') : '--'}}</td>
          <td>{{record.prezzocert ? (record.prezzocert | number:'1.0-2':'fr') : '--'}}</td>
          <td>{{record.rts ? (record.rts | number:'1.0-2') : '--'}}</td>
          <td>{{record.sconto ? (record.sconto/100 | percent:'1.0-2') : '--'}}</td>
          <td>
            <a (click)="addToWatchlist(record.isin)" matTooltip="Aggiungi isin ad una watchlist">
              <img [src]="'assets/images/icons/addToWatchlistGlassesSmall.png'" alt="Aggiungi alla watchlist" class="watchlistIcon">
            </a>
          </td>
        </tr>
      </tbody>
      <tfoot *ngIf="!showLoader" class="footer-view-all">
      <tr>
        <td colspan="100%">
          <a class="nav-link" [routerLink]="store.viewAllPath">
            <i class="fa fa-plus"></i> Visualizza tutti
          </a>
        </td>
      </tr>
      </tfoot>
    </table>
    <div class="d-flex justify-content-center">
      <app-loader *ngIf="showLoader"></app-loader>
    </div>
  </div>

</div>

<div [hidden]="!isGuest" class="container-fluid mt-3" style="position: relative"
  *ngIf="style === tableStyle.Extended">
  <div class=" table-header d-flex">
    <h4 class="view-all-table-title">
      {{store.title}}
    </h4>
    <a>
      <button type="button" class="btn btn-light" *ngIf="tableInfoExists" (click)="openDialog()"><i
          class="fa fa-info-circle fa-sm"></i></button>
    </a>
  </div>
  <div class="table-responsive">
    <table class="table footable" data-paging="true" data-filtering="true" data-sorting="true"
      data-breakpoints='{ "xs": 480, "sm": 768, "md": 992, "lg": 1200, "xl": 1400 }' matSort
      (matSortChange)="deepSortRecords($event)">
      <thead class="thead-dark">
        <tr>
          <th scope="col" mat-sort-header="Isin">Isin</th>
          <th scope="col" mat-sort-header="Emittente">Emittente</th>
          <th scope="col" mat-sort-header="Nome">Nome</th>
          <th scope="col" mat-sort-header="Sottostante">Sottostante</th>
          <th scope="col" mat-sort-header="Scadenza">Scadenza</th>
          <th scope="col" mat-sort-header="Strike">Strike</th>
          <th scope="col" mat-sort-header="Protezione">Protezione</th>
          <th scope="col" mat-sort-header="Cap">Cap</th>
          <th scope="col" mat-sort-header="Prezzo Sott.">Prezzo Sott.</th>
          <th scope="col" mat-sort-header="Prezzo Cert.">Prezzo Cert.</th>
          <th scope="col" mat-sort-header="Rts">Rts</th>
          <th scope="col" mat-sort-header="Sconto">Sconto</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let record of store.sortedRecordsGuest">
          <td><a [routerLink]="['/menu/scheda-certificato']" [queryParams]="{ isin: record.isin }">{{record.isin ? record.isin : '--'}}</a></td>
          <td>{{record.emittente ? record.emittente : '--'}}</td>
          <td>{{record.nome ? record.nome : '--'}}</td>
          <td *ngIf="record.sottostante">
            <a [routerLink]="[ '/menu/sottostante']"
              [queryParams]="{ sottostante: record.sottostante}">{{record.sottostante ? record.sottostante : '--'}}</a>
          </td>
          <td *ngIf="!record.sottostante">
            n/a
          </td>
          <td>{{record.scadenza ? (record.scadenza | date:'dd/MM/yyyy') : '--'}}</td>
          <td>{{record.strike ? (record.strike | number:'1.0-2':'fr') : '--'}}</td>
          <td>{{record.protezione ? (record.protezione | number:'1.0-2':'fr') : '--'}}</td>
          <td>{{record.cap ? (record.cap | number:'1.0-2':'fr') : '--'}}</td>
          <td>{{record.prezzosott ? (record.prezzosott | number:'1.0-4':'fr') : '--'}}</td>
          <td>{{record.prezzocert ? (record.prezzocert | number:'1.0-2':'fr') : '--'}}</td>
          <td>{{record.rts ? (record.rts | number:'1.0-2':'fr') : '--'}}</td>
          <td>{{record.sconto ? (record.sconto/100 | percent:'1.0-2':'fr') : '--'}}</td>
          <td>
            <a (click)="addToWatchlist(record.isin)" matTooltip="Aggiungi isin ad una watchlist predefinita">
              <img [src]="'assets/images/icons/addToWatchlistGlassesSmall.png'" alt="Aggiungi alla watchlist" class="watchlistIcon">
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div [ngClass]="showLoader ? 'd-flex justify-content-center loading' : 'd-flex justify-content-center'">
    <app-loader *ngIf="showLoader"></app-loader>
  </div>
</div>
